export default {
  update: 'nautaGet',
}